/**
 * adminApi.js — Admin client for /api/club/admin/* endpoints.
 * Uses the existing consoleApi (Bearer token from /mira/console login).
 *
 * FIR-20260611-001 · admin console
 */

import { consoleApi } from "@/lib/console-auth";

export async function listClubs(params = {}) {
  const { data } = await consoleApi.get("/club/admin/clubs", { params });
  return data;
}

export async function getClub(idShort) {
  const { data } = await consoleApi.get(`/club/admin/clubs/${idShort}`);
  return data.club;
}

export async function createClub(payload) {
  const { data } = await consoleApi.post("/club/admin/clubs", payload);
  return data;
}

export async function patchClub(idShort, patch) {
  const { data } = await consoleApi.patch(`/club/admin/clubs/${idShort}`, patch);
  return data;
}

export async function deleteClub(idShort, { hard = false, reason = "" } = {}) {
  const params = {};
  if (hard) params.hard = true;
  if (reason) params.reason = reason;
  const { data } = await consoleApi.delete(`/club/admin/clubs/${idShort}`, { params });
  return data;
}

export async function uploadClubImage(idShort, file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await consoleApi.post(
    `/club/admin/clubs/${idShort}/image`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
}

export async function deleteClubImage(idShort) {
  const { data } = await consoleApi.delete(`/club/admin/clubs/${idShort}/image`);
  return data;
}

export async function listAmenities() {
  const { data } = await consoleApi.get("/club/admin/amenities");
  return data;
}

export async function addAmenity(value) {
  const { data } = await consoleApi.post("/club/admin/amenities", { value });
  return data;
}
